<template>
  <fragment>
    <AppBody
      title="Produtores / Usuários"
      subtitle="Cadastrar - Editar"
      :actions="isNewRegister ? [] : actions"
    >
      <div class="lojas-usuarios-add-edit-container10">
        <v-row>
          <v-col
            cols="12"
            class="py-10"
            style="text-align: center"
            v-if="!$lojas_usuarios.cadastro.photo.imagem"
          >
            <UploadIcon customizedClass="upload-icon" />
            <v-file-input
              show-size
              accept="image/png, image/jpeg, image/bmp"
              :rules="rules"
              placeholder="Escolha uma foto"
              v-model="$lojas_usuarios.cadastro.photo.object"
              @change="getImagem($lojas_usuarios.cadastro.photo.object)"
              append-icon="mdi-image-outline"
              prepend-icon=""
            >
            </v-file-input>
          </v-col>
          <v-col cols="12" class="py-10" v-else>
            <v-avatar width="150" height="150">
              <label for="imagemupload" class="avatar-label">
                <v-img
                  class="img-user"
                  max-height="180"
                  max-width="160"
                  :src="$lojas_usuarios.cadastro.photo.imagem"
                ></v-img>
                <v-file-input
                  id="imagemupload"
                  show-size
                  accept="image/png, image/jpeg, image/bmp"
                  :rules="rules"
                  placeholder="Escolha uma foto para atualizar"
                  style="display: none"
                  v-model="$lojas_usuarios.cadastro.photo.object"
                  @change="getImagem($lojas_usuarios.cadastro.photo.object)"
                ></v-file-input>
              </label>
            </v-avatar>
          </v-col>
        </v-row>
        <v-form class="search-forms">
          <v-row class="d-flex justify-center">
            <v-col cols="4">
              <label required class="input-labels">Nome</label>
              <v-text-field
                solo
                placeholder="Ex: João da Silva"
                v-model="$lojas_usuarios.cadastro.nome"
                type="text"
                data-cy="nome"
                class="textinput"
                :error-messages="$lojas_usuarios.cadastro.error.nome"
                @input="$lojas_usuarios.cadastro.error.nome = []"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-center">
            <v-col cols="4">
              <label required class="input-labels">E-mail</label>
              <v-text-field
                solo
                required
                placeholder="seuemail@email.com"
                v-model="$lojas_usuarios.cadastro.email"
                type="email"
                data-cy="email"
                class="textinput"
                :error-messages="$lojas_usuarios.cadastro.error.email"
                @input="$lojas_usuarios.cadastro.error.email = []"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-center" v-if="isNewRegister">
            <v-col cols="4">
              <label required class="input-labels">Senha</label>
              <v-text-field
                solo
                required
                placeholder="******"
                v-model="$lojas_usuarios.cadastro.senha"
                :type="showSenha ? 'text' : 'password'"
                :append-icon="
                  showSenha ? $config.icons.viewOff : $config.icons.view
                "
                @click:append="showSenha = !showSenha"
                data-cy="senha"
                class="textinput"
                :error-messages="$lojas_usuarios.cadastro.error.senha"
                @input="$lojas_usuarios.cadastro.error.senha = []"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-center">
            <v-col cols="4">
              <label required class="input-labels">Status</label>
              <v-select
                height="48"
                :items="status"
                item-text="key"
                item-value="value"
                dense
                solo
                data-cy="status"
                class="textinput"
                v-model="$lojas_usuarios.cadastro.status"
                required
                placeholder="Selecione o status"
                :error-messages="$lojas_usuarios.cadastro.error.status"
                @input="$lojas_usuarios.cadastro.error.status = []"
              ></v-select>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-center">
            <v-col cols="4">
              <label required class="input-labels">Perfil</label>
              <v-select
                height="48"
                item-text="key"
                item-value="value"
                dense
                :items="perfil"
                solo
                data-cy="perfil"
                class="textinput"
                v-model="$lojas_usuarios.cadastro.perfil"
                required
                placeholder="Selecione o perfil"
                :error-messages="$lojas_usuarios.cadastro.error.perfil"
                @input="$lojas_usuarios.cadastro.error.perfil = []"
              ></v-select>
            </v-col>
          </v-row>
        </v-form>
      </div>
      <RegistrationActions
        :fixed="true"
        :loader="$lojas_usuarios.cadastro.loading"
        :actions="registrationActions"
      />
    </AppBody>
  </fragment>
</template>

<script>
import _ from "lodash";
export default {
  name: "UsersSettings",
  metaInfo: {
    title: "Usuários | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Usuários | ElevenTickets",
      },
    ],
  },
  props: {},
  components: {
    AppBody: () => import("@/layouts/components/AppBody.vue"),
    RegistrationActions: () =>
      import("@/components/global/RegistrationActions.vue"),
    UploadIcon: () => import("@/components/icons/UploadIcon.vue"),
  },
  data() {
    return {
      actions: [
        {
          name: "Enviar Login e Conta por E-mail",
          action: () => this.$lojas_usuarios.sendAppLoginInfoEmailNoPassword(),
        },
      ],
      registrationActions: [
        {
          name: "Salvar",
          action: () => this.$lojas_usuarios.validarCadastro(),
        },
        {
          name: "Cancelar",
          action: () => this.$router.push({ name: "producersUsers" }),
        },
      ],
      cadastro: {
        perfil: [],
      },
      showSenha: false,
      perfis: [
        "Operações",
        "Atendimento B2B",
        "Atendimento B2C",
        "Configurador",
        "Financeiro",
        "Analista",
        "Gerente",
        "Diretor",
        "Jurídico",
        "Admin",
        "Comercial",
      ],
      perfil: [
        {
          key: "LOJISTA",
          value: "LOJISTA",
        },
        {
          key: "APP",
          value: "APP",
        },
        {
          key: "ADMIN",
          value: "ADMIN",
        },
      ],
      status: [
        {
          key: "Ativo",
          value: "ATIVO",
        },
        {
          key: "Aceite Termos",
          value: "ACEITE_TERMOS",
        },
        {
          key: "Inativo",
          value: "INATIVO",
        },
      ],

      rules: [v => !v || v.size < 2000000 || "Imagem deve ser menor que 2 MB!"],
    };
  },
  computed: {
    isNewRegister() {
      if (this.$route.params.type === "cadastrar") return true;
      else return false;
    },
  },
  methods: {
    getImagem(file) {
      const self = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        self.$lojas_usuarios.cadastro.photo.imagem = reader.result;
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
    },
    setProfile(array, profile, newArray) {
      var profileIndex = array.indexOf(profile);
      if (profileIndex > -1) {
        array.splice(profileIndex, 1);
      }
      newArray.push(profile);
    },
    btnBack() {
      this.$lojas_usuarios.limpaFormularioDeUsuario();
    },
  },
  mounted() {
    this.perfis = _.difference(
      this.perfis,
      this.$lojas_usuarios.cadastro.perfil
    );
  },
  destroyed() {
    this.$lojas_usuarios.limpaFormularioDeUsuario();
  },
};
</script>

<style scoped>
.img-user:hover {
  cursor: pointer;
}

.lojas-usuarios-add-edit-container10 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 2rem;
}
.upload-icon {
  height: 10rem !important;
  width: 10rem !important;
}
</style>
